import { LoadingOutlined } from '@ant-design/icons';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import HubspotForm from 'react-hubspot-form';

import './style.css';

export const RequestExternalIntegration = () => (
  <HubspotForm
    cssClass='hs-form'
    formId='07f5136d-862f-46d1-8332-7130b9ec3f6a'
    loading={<LoadingOutlined />}
    portalId='144451175'
    region='eu1'
  />
);
